module.exports = __webpack_public_path__ + "img/business-valuation-1.52d852f2.png";